import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import styles from './globalScrolling.module.scss';

export const useBlockGlobalScrolling = (disabled?: boolean) => {
    const [isBlocked, setBlocked] = useState(false);

    const disableGlobalScrolling = useCallback(() => {
        if (!isBlocked) {
            setBlocked(true);
            document.body.className = classNames(
                document.body.className,
                styles.blockScrolling,
            );
        }
    }, [isBlocked]);

    const enableGlobalScrolling = useCallback(() => {
        if (isBlocked) {
            setBlocked(false);
            document.body.className = document.body.className
                .replace(styles.blockScrolling, '')
                .trim();
        }
    }, [isBlocked]);

    useEffect(() => {
        if (disabled) {
            disableGlobalScrolling();
        } else {
            enableGlobalScrolling();
        }

        return () => {
            enableGlobalScrolling();
        };
    }, [disabled, disableGlobalScrolling, enableGlobalScrolling]);

    return {
        enableGlobalScrolling,
        disableGlobalScrolling,
    };
};
